<template>
    <div class="product">
        <div
            v-if="product.badge"
            class="add-badge"
            :class="product.badge.text ? 'blank' : product.badge.className"
        >
            <p v-if="product.badge.text" v-html="product.badge.text"></p>
        </div>

        <div
            class="product-header"
            :class="{ 'left-align': product.headerLeftAlign }"
        >
            <p>{{ product.title }}</p>
            <p>{{ product.subtitle }}</p>
        </div>

        <div class="product-body">
            <template v-if="product.price.original">
                <div class="break-line"></div>
                <p class="price original">{{ product.price.original }}</p>
            </template>

            <p class="price discount">{{ product.price.discount }}</p>

            <p
                v-if="product.bonusDesc || product.bonusDescHidden"
                class="price-desc new"
                :class="{ hide: product.bonusDescHidden }"
            >
                {{ product.bonusDesc }}
            </p>

            <p v-if="product.priceDesc" class="price-desc">
                {{ product.priceDesc }}
            </p>

            <p
                v-if="product.subDesc.text"
                class="price-desc sub"
                :class="{ color: product.subDesc.colored }"
            >
                {{ product.subDesc.text }}
            </p>

            <button @click="$emit('purchase', product.link)">立即购买</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MembershipProductCard',
    props: {
        /** membershipProducts.js 의 normalizeProduct() 반환 형태만 받는다 */
        product: {
            type: Object,
            required: true
        }
    }
}
</script>
